import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BannerFichas from '../../components/BannerFichas/BannerFichas';
import Navbar from '../../components/Navbar/Navbar';
import SessionBar from '../../components/SessionBar/SessionBar';
import Footer from '../../components/Footer/Footer';
import DetalleJuegoHis from '../../components/DetalleJuego/DetalleJuegoHis/DetalleJuegoHis';
import { fetchUserData } from '../../utils/api';

const HistorialJugador = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 flex-grow">
        <Navbar />
        {userData && <SessionBar />}
        <DetalleJuegoHis userId={userId} />
      </div>
      <Footer />
    </div>
  );
};

export default HistorialJugador;
